module.exports = __webpack_public_path__ + "static/media/DSC_0124.7936a8d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0124.jpg
// module id = 557
// module chunks = 0